if (!customElements.get('hafizah-payment-methods')) {
  customElements.define('hafizah-payment-methods', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const details = this.querySelector('details');
      if (!details) return;
      const summary = details.querySelector('summary');
      const panel = details.querySelector('.hz-payment-panel');
      const closeButton = details.querySelector('.hz-payment-close');
      const fitPanel = () => {
        if (!details.open) return;
        ['max-height', 'position', 'top', 'bottom', 'left', 'right', 'width', 'inset-inline-end'].forEach(property => panel.style.removeProperty(property));
        const header = document.querySelector('sticky-header');
        const safeTop = Math.max(12, (header?.getBoundingClientRect().bottom || 0) + 12);
        const availableAbove = this.getBoundingClientRect().top - 12 - safeTop;
        if (availableAbove >= 160) {
          panel.style.maxHeight = `${Math.min(480, window.innerHeight * 0.6, availableAbove)}px`;
        } else {
          const width = Math.min(680, window.innerWidth - 48);
          const left = Math.max(24, Math.min(window.innerWidth - width - 24, this.getBoundingClientRect().left));
          Object.assign(panel.style, { position: 'fixed', insetInlineEnd: 'auto', left: `${left}px`, right: 'auto', top: `${safeTop}px`, bottom: 'auto', width: `${width}px`, maxHeight: `${Math.max(120, window.innerHeight - safeTop - 24)}px` });
        }
      };
      const close = (restoreFocus = false) => {
        details.open = false;
        if (restoreFocus) summary.focus({ preventScroll: true });
      };
      closeButton.hidden = false;
      details.addEventListener('toggle', fitPanel, { signal });
      window.addEventListener('resize', fitPanel, { signal, passive: true });
      window.addEventListener('scroll', fitPanel, { signal, passive: true });
      details.addEventListener('focusout', () => {
        // Let the browser finish moving focus before deciding it left the panel.
        setTimeout(() => {
          if (details.open && !details.contains(document.activeElement)) close();
        }, 0);
      }, { signal });
      closeButton.addEventListener('click', () => close(true), { signal });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          close(true);
        }
      }, { signal });
      document.addEventListener('pointerdown', (event) => {
        if (details.open && !details.contains(event.target)) close();
      }, { signal });
      document.addEventListener('shopify:block:select', (event) => {
        if (panel.contains(event.target)) details.open = true;
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
